import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/utils/analytics-tracking";

interface UsePageTrackingOptions {
  /**
   * false로 설정하면 트래킹이 비활성화된다.
   * 기본값: true
   */
  enabled?: boolean;
}

/**
 * React Router 6의 location 변경을 감지하여 페이지 뷰를 Firebase Analytics에 기록한다.
 *
 * - PII 마스킹은 trackPageView 내부에서 처리된다.
 * - React Strict Mode의 이중 실행으로 인한 중복 트래킹을 ref로 방지한다.
 *
 * @example
 * // App.tsx (admin-web)
 * function App() {
 *   usePageTracking();
 *   return <RouterOutlet />;
 * }
 */
export function usePageTracking({ enabled = true }: UsePageTrackingOptions = {}): void {
  const { pathname } = useLocation();
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      lastTrackedPath.current = null;
      return;
    }

    if (lastTrackedPath.current === pathname) return;

    lastTrackedPath.current = pathname;
    trackPageView(pathname);
  }, [pathname, enabled]);
}
